import { uniq } from "@utils/toolBox";
import { getRegionOptions } from "@utils/constants/regions";
import { ref } from "vue";

export const useSurveyTargets = () => {
  const countryOptions = ref(getRegionOptions());
  const countryLabel = (countryCode) => countryOptions.value.find(({ value }) => value === countryCode)?.label;

  const targetCountries = (targets) => uniq(targets?.map(({ countries }) => countries).flat());
  const isMultiCountry = (targets) => targetCountries(targets)?.length > 1;
  const firstTargetCountry = (targets) => (targets?.[0]?.countries?.[0] ?? "fr").toLowerCase();
  const determineCountryInfo = (targets) => uniq(targets.map((t) => t.countries.map((c) => countryLabel(c))).flat());

  return {
    isMultiCountry,
    determineCountryInfo,
    firstTargetCountry,
  };
};
